const MailToAFDM = ({ children }) => {
  return (
    <a className="mail-to-afdm" href="mailto:bonjour@afdm.fr">
      {children}
    </a>
  );
};

export default MailToAFDM;
